const TOPICS = {
  PoolCreated:
    '0xa9ba3ffe0b6c366b81232caab38605a0699ad5398d6cce76f91ee809e322dafc',
};

export default TOPICS;
